export default "__VITE_ASSET__C2vnjj7W__"